<div class="admin-link" (click)="onClick()"></div>